import { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { Quotation } from '../../../../../../shared/types/modules/quotation';
import { QuotationCallInfoProps } from './props';
import { ISelect, ParamEnum } from '../../../../../../shared/types/shared';
import { asyncGetParams } from '../../../../../../services/param.service';

import { asyncGetTemplateByCode } from '../../../../../../services/template.service';

export const useQuotationCallInfo = ({
    data,
    onChangeData,
    onChangeFormik,
}: QuotationCallInfoProps) => {
    const [bouquets, setBouquets] = useState<ISelect[]>([]);
    const [typeQuotations, setTypeQuotations] = useState<ISelect[]>([]);
    const [typifications, setTypification] = useState<ISelect[]>([]);
    const [subtypifications, setSubtypification] = useState<ISelect[]>([]);
    const [channels, setChannels] = useState<ISelect[]>([]);

    const onSubmit = (data: Quotation) => {
        if (onChangeData) onChangeData(data || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema: validationSchema(subtypifications.length > 0),
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue('callId', data?.callId || '');
        formik?.setFieldValue('channel', data?.channel || '');
        formik?.setFieldValue('bouquet', data?.bouquet || '');
        formik?.setFieldValue('typification', data?.typification || '');
        formik?.setFieldValue('subtypification', data?.subtypification || '');
        formik?.setFieldValue('typeQuotation', data?.typeQuotation || '');
        formik?.setFieldValue('template', data?.template || '');
        formik?.setFieldValue('body', data?.body || '');
    }, [data]);

    useEffect(() => {
        asyncGetParams(ParamEnum.CASES_GENERAL_INFORMATION_CHANNEL).then(
            (params) => setChannels(params)
        );
        asyncGetParams(ParamEnum.QUOTATION_TYPIFICATION).then((params) =>
            setTypification(params)
        );
        asyncGetParams(ParamEnum.QUOTATION_BOUQUET).then((items) =>
            setBouquets(items)
        );
        asyncGetParams(ParamEnum.QUOTATION_TYPE).then((items) =>
            setTypeQuotations(items)
        );
    }, []);

    useEffect(() => {
        if (Boolean(formik.values.typification)) {
            asyncGetParams(
                ParamEnum.QUOTATION_SUBTYPIFICATION,
                undefined,
                formik.values.typification
            ).then((items) => setSubtypification(items));
        }

        if (!data || !Boolean(data.typification)) {
            formik.setFieldValue('subtypification', '');
        }
        setSubtypification([]);
    }, [formik.values.typification]);

    useEffect(() => {
        if (data?.typification !== formik.values.typification) {
            const typification = typifications.find(
                (element) => element.id === formik.values.typification
            );

            if (typification) {
                let template_type = '';

                if (
                    typification.code === 'QUOTATION_TYPIFICATION_001' ||
                    typification.code === 'QUOTATION_TYPIFICATION_003' ||
                    typification.code === 'QUOTATION_TYPIFICATION_009'
                ) {
                    template_type = ParamEnum.QUOTATION_AUTOMOBILES;
                } else if (
                    typification.code === 'QUOTATION_TYPIFICATION_005' ||
                    typification.code === 'QUOTATION_TYPIFICATION_006' ||
                    typification.code === 'QUOTATION_TYPIFICATION_007' ||
                    typification.code === 'QUOTATION_TYPIFICATION_008' ||
                    typification.code === 'QUOTATION_TYPIFICATION_017' ||
                    typification.code === 'QUOTATION_TYPIFICATION_018' ||
                    typification.code === 'QUOTATION_TYPIFICATION_019'
                ) {
                    template_type = ParamEnum.QUOTATION_PREVI;
                } else if (typification.code === 'QUOTATION_TYPIFICATION_002') {
                    template_type = ParamEnum.QUOTATION_PREVI_HOME;
                } else if (typification.code === 'QUOTATION_TYPIFICATION_016') {
                    template_type = ParamEnum.QUOTATION_PREVI_GOODS_TRANSPORT;
                } else {
                    template_type = ParamEnum.QUOTATION_PREVI_COMMON_AREAS;
                }

                asyncGetTemplateByCode(template_type).then((res) => {
                    formik.setFieldValue('body', res?.body || '');
                    formik.setFieldValue('template', res?.id || '');
                });
            } else {
                formik.setFieldValue('body', data?.body || '');
                formik.setFieldValue('template', data?.template || '');
            }
        }
    }, [formik.values.typification, typifications]);

    return {
        formik,
        channels,
        typifications,
        subtypifications,
        bouquets,
        typeQuotations,
    };
};
